<template>
  <div class="main dl_gray_color_bg">
    <mt-header :title="$t('我的积分')" class="dl_header_white dl_line_bottom" fixed>
      <mt-button icon="back" slot="left" @click="goback"></mt-button>
    </mt-header>

    <div class="box-all">

      <div class="container">
        <div class="reg f16">{{$t('当前总额')}}</div>
        <div class="num f18">{{score}} {{$t('积分')}}</div>
        <hr/>
        <div class="reg f14">{{$t('今日获得')}} {{today_amount}} {{$t('积分')}} <span class="fr" @click="query()">{{$t('积分账单')}}</span></div>
      </div>

      <div class="container2">
        <div class="footer">
          <div class="item" @click="task()">
            <div class="detail">
              <span class="fb">{{$t('任务')}}</span>
            </div>
          </div>
          <div class="line"></div>
          <div class="item right" @click="shop()">
            <div class="detail">
              <span class="fb">{{$t('商城')}}</span>
            </div>
          </div>
        </div>
      </div>




    </div>


  </div>
</template>

<script>
import { Toast } from "mint-ui";
import { httpGetInvitationInfo } from "@/api/userCenter";
import { httpScoreInfo } from "@/api/index";
export default {
  name: "InvitationDetail",
  components: { Toast },
  data() {
    return {
      score:0,
      today_amount:0
    };
  },
  methods: {
    goback: function() {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push("/");
    },
    task: function() {
      this.$router.push({path:"/task"});
    },
    shop: function() {
      this.$router.push({path:"/shop"});
    },
    query(){
        this.$router.push('/myccorder')
    },
    getInfo: function() {
      httpScoreInfo()
        .then(res => {
          this.score = res.data.score;
          this.today_amount = res.data.today_amount;
        })
        .catch(() => {});
    }
  },
  mounted() {},
  activated: function() {
    this.getInfo();
  }
};
</script>

<style lang="less" scoped>
.main {
  padding-top: 40px;
  height: 100%;
  box-sizing: border-box;
}
.fr{
  float: right;
}
/*邀请注册列表*/
.content_detail{
  padding:0 15px 0 15px;
  min-height: 100px;
  background-color: #fff;
}
.content_detail li{width:100%;background:#fff;margin-top:12px;height: 98px;}
.yao_empty{
  line-height: 70px;
  font-weight:bold;
  color:#8a8ca5;
}
.oImg{
    width: 34px;
    height: 34px;
    margin: 15px 10px 5px 14px;
}
.currency_name{
  position: relative;
    top: -20px;
    font-size: 14px;
    font-weight: bold;
}
.amount_of{width:25%;text-align: center;}
.count{color:#0191f5;padding:22px 0 10px 0;font-weight: bold;}
.money{color:#8c92a8;}

.box-all{
  padding: 20px 5%;
}
.container2{
  text-align: center;
  padding: 25px 0;
  .yao_title{
    padding: 30px 0 20px 0;
  } 
  .footer{
    width:100%;
    height:50px;
    position: relative;
    .item{
      width: 47%;
      height: 100%;
      font-size: 16px;
      color: #fff;
      text-align: center;
      background: #475fd8;
      position: absolute;
      top: 0;
      border-radius: 5px;
      .detail{
        position: absolute;
        width: 80px;
        left: 50%;
        margin: 0 0 0 -40px;
        line-height: 50px;
        span{
          border:1px;
        }
      }
    }
    .item.active{
      color:#335bdc;
      .detail{
        border-bottom: 2px solid #335bdc;
      }
    }
  }
.footer .item.right{
    right: 0;
}





}
.fb{
  font-weight: bold;
}
.h40{
  height: 40px;
}
.l50{
  line-height: 50px;
}
.f20{
  font-size: 20px;
  font-weight: bold;
  line-height: 50px;
}
.f18{
  font-size: 18px;
}
.f16{
  font-size: 16px;
}
.f14{
  font-size: 14px;
}
.f12{
  font-size: 12px;
}
.num,.reg{
  text-align: center;
}
.container {
  padding: 20px;
  background-color: #1d3d57;
  border-radius: 10px;
  color:#fff;
  .title{
    padding: 20px 0 0 0;
    color: #ffe6ac;
  }
  .num{
    color: #ffe6ac;
    font-size: 20px;
    font-weight: bold;
    padding: 20px 0 10px 0;
  }
  hr{
    margin: 20px 0;
    height:1px;
    border:0px;
    border-top:1px solid #666875;
    padding:0px;
    overflow:hidden;
    font-size:0px;
  }
  .top,.bottom{
    padding: 0 !important;
    line-height: 25px;
    height: 50px;
    width: 100%;
    position: relative;
    font-size: 20px;
    .left{
      width: 30%;
      position: absolute;
      left: 0;
      top:0;
      text-align: center;
    }
    .middle{
      width: 40%;
      position: absolute;
      left: 30%;
      top:0;
      text-align: center;
    }
    .right{
      width: 30%;
      position: absolute;
      right: 0;
      top:0;
      text-align: center;
    }
  }
}

</style>

